import {
  Component,
  EventEmitter,
  Input,
  IterableDiffer,
  IterableDiffers,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { sortWidgetsBySpace, updateWidgetIndex } from '@emma-helpers/widget.helper';
import { PdfExportedElement } from '@emma-services/export-pdf.service';
import { OnUnsubscribe } from '@platform/helpers/on-unsubscribe.class';
import { CustomDashboardsInfo, CustomDashboardsInfoChart } from 'emma-common-ts/emma';
import { find } from 'lodash';

@Component({
    selector: 'emma-dashboard',
    templateUrl: './emma-dashboard.component.html',
    standalone: false
})
export class EMMADashboardComponent extends OnUnsubscribe implements OnInit, OnChanges {
  @Input()
  dashboard!: CustomDashboardsInfo;
  @Input()
  isEdit = false;
  @Input()
  isExport = false;
  @Output()
  exported = new EventEmitter<PdfExportedElement>();
  @Output()
  update = new EventEmitter<CustomDashboardsInfoChart[]>();
  @Output()
  edit = new EventEmitter<CustomDashboardsInfoChart>();

  private _dragging: CustomDashboardsInfoChart | undefined;
  @Input()
  widgets: CustomDashboardsInfoChart[] = [];
  differ: IterableDiffer<CustomDashboardsInfoChart>;

  constructor(differs: IterableDiffers) {
    super();
    this.differ = differs.find([]).create();
  }

  ngOnInit(): void {
    if (this.widgets) {
      this.update.emit(this.getWidgets());
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isEdit) {
      this.update.emit(this.getWidgets());
    }
  }

  getWidget(id: string): CustomDashboardsInfoChart | undefined {
    return find(this.widgets, { id });
  }

  getWidgets(): CustomDashboardsInfoChart[] {
    return this.updateWidgets(this.widgets);
  }

  /*
    Editable widget hooks
  */
  onEditWidget = (widget: CustomDashboardsInfoChart): void => {
    const _widget = this.getWidget(widget.id);
    if (_widget) {
      this.edit.emit(_widget);
    }
  };
  onExpandWidget = (widget: CustomDashboardsInfoChart): void => {
    const _widget = this.getWidget(widget.id);
    if (_widget) {
      _widget.fullSize = !widget.fullSize;
    }
  };
  onRemoveWidget = (widget: CustomDashboardsInfoChart): void => {
    this.update.emit(this.getWidgets().filter((w) => w.id !== widget.id));
  };
  onDrop = (event: any): void => {
    const { dropIndex } = event;
    if (this._dragging) {
      const widgets = updateWidgetIndex(this.moveWidget(this._dragging, dropIndex));
      this._dragging = undefined;
      this.update.emit(this.updateWidgets(widgets));
    }
  };
  onDrag = (widget: CustomDashboardsInfoChart, event: any): void => {
    this._dragging = widget;
  };
  onExport(data: PdfExportedElement): void {
    this.exported.emit(data);
  }

  /*
  Utilities
  */

  moveWidget(one: CustomDashboardsInfoChart, index: number): CustomDashboardsInfoChart[] {
    const oldIndex = Number(one.index);
    index = index >= this.widgets.length ? this.widgets.length - 1 : index;
    this.widgets.splice(index, 0, this.widgets.splice(oldIndex, 1)[0]);
    return this.widgets;
  }

  updateWidgets = (widgets: CustomDashboardsInfoChart[] = this.widgets): CustomDashboardsInfoChart[] => {
    return sortWidgetsBySpace(widgets);
  };
}
